import { getProfileCollaborators } from "Admin/Service/Profile";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { ImageCheck, LoadingListEntityProfile } from "Explore/Components";
import { ImageCheckType } from "Explore/Config/ImageType";
import { Empty, Segmented, Tag } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Collaborators.module.scss";
const Collaborators = () => {
  const [data, setData] = useState({ data: [], isLoading: true });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [collaboratorTab, setCollaboratorTab] = useState("Internal");
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfileCollaborators(
      pagination.page - 1,
      pagination.rowsPerPage,
      (res) => {
        handleAPIResponse(res, () => {
          setData({
            data: res.data.collaborators,
            isLoading: false,
          });
        });
      }
    );
  }, []);
  const Collaborator = ({ peer }) => {
    const navigate = useNavigate();
    return (
      <div className={styles["collaborator"]}>
        <div className={styles["avatar"]}>
          <ImageCheck
            url={peer.researcher_photo_url}
            className={styles["photo"]}
            alt={"avatar"}
            type={ImageCheckType.FACULTY_AVATAR}
          />
        </div>
        <div className={styles["info"]}>
          <div
            onClick={() => {
              navigate(`/explore/faculty/${peer.explore_slug || peer.id}`);
              window.location.reload();
            }}
          >
            <p className={styles["name"]}>{peer.researcher_name}</p>
          </div>
          <p className={styles["inst-name"]}>{peer.institution_name}</p>
          <p className={styles["position"]}>{peer.researcher_position}</p>
          <div className={styles["tags"]}>
            {window.screen.width < 480
              ? peer.researcher_keywords.slice(0, 3)?.map((item, index) => {
                  return (
                    <Tag
                      key={index}
                      color="var(--light-blue)"
                      style={{ cursor: "pointer" }}
                    >
                      {item.id}
                    </Tag>
                  );
                })
              : peer.researcher_keywords?.map((item, index) => {
                  return (
                    <Tag
                      key={index}
                      color="var(--light-blue)"
                      style={{ cursor: "pointer" }}
                    >
                      {item.id}
                    </Tag>
                  );
                })}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles["collaborators"]}>
      <Segmented
        style={{ marginBottom: "20px" }}
        options={["Internal", "External"]}
        defaultValue={collaboratorTab}
        value={collaboratorTab}
        onChange={setCollaboratorTab}
      />
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data?.data?.length > 0 ? (
            data?.data?.map((item, index) => {
              return <Collaborator key={index} peer={item} />;
            })
          ) : (
            <Empty description="No Peer Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
    </div>
  );
};

export default Collaborators;
